import * as React from 'react';
import {Svg, 
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';
/* SVGR has dropped some elements not supported by react-native-svg: filter */

const DiscoverCard = props => {
  return (
    <Svg
      width={46}
      height={30}
      viewBox="0 0 46 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G clipPath="url(#clip0_24105_13370)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.517 2.114C.517.947 1.463 0 2.63 0h40.875c1.167 0 2.114.947 2.114 2.114v25.37a2.114 2.114 0 01-2.114 2.115H2.63a2.114 2.114 0 01-2.114-2.114V2.115z"
          fill="url(#paint0_linear_24105_13370)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.517 1.5a1.5 1.5 0 011.5-1.5h29a1.5 1.5 0 011.5 1.5v18a1.5 1.5 0 01-1.5 1.5h-29a1.5 1.5 0 01-1.5-1.5v-18z"
          fill="#E5E5E5"
          fillOpacity={0.01}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.406 15.975c-.296.27-.682.387-1.292.387h-.253v-3.221h.253c.61 0 .98.11 1.292.394.327.292.523.746.523 1.213 0 .467-.196.935-.523 1.227zm-1.103-3.66H7.917v4.871h1.379c.733 0 1.263-.174 1.728-.562a2.45 2.45 0 00.879-1.87c0-1.438-1.068-2.44-2.6-2.44zM12.337 17.186h.944v-4.871h-.944v4.871zM15.59 14.184c-.566-.21-.732-.35-.732-.613 0-.307.296-.54.703-.54.283 0 .516.117.762.394l.494-.65a2.111 2.111 0 00-1.423-.54c-.857 0-1.51.598-1.51 1.395 0 .671.304 1.015 1.191 1.336.37.132.558.219.653.278.189.124.283.3.283.504 0 .395-.311.687-.733.687-.45 0-.813-.227-1.03-.65l-.61.591c.434.643.957.928 1.676.928.981 0 1.67-.657 1.67-1.6 0-.774-.319-1.124-1.393-1.52zM17.281 14.755c0 1.432 1.118 2.542 2.556 2.542.406 0 .755-.08 1.184-.284v-1.119c-.378.38-.712.534-1.14.534-.951 0-1.627-.694-1.627-1.68 0-.936.697-1.674 1.583-1.674.45 0 .791.162 1.184.548v-1.118c-.415-.211-.755-.299-1.162-.299-1.43 0-2.578 1.133-2.578 2.55zM28.51 15.587l-1.292-3.272h-1.032l2.055 4.996h.508l2.092-4.996h-1.024l-1.308 3.272zM31.269 17.186h2.678v-.824h-1.735v-1.315h1.671v-.826h-1.67V13.14h1.734v-.825h-2.678v4.871zM35.79 14.557h-.275v-1.475h.29c.59 0 .909.248.909.722 0 .49-.32.753-.923.753zm1.896-.804c0-.912-.625-1.438-1.714-1.438h-1.4v4.871h.943V15.23h.123l1.308 1.957h1.161l-1.524-2.052c.711-.146 1.103-.635 1.103-1.381z"
          fill="#212D34"
        />
        <G filter="url(#filter0_i_24105_13370)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.481 14.767a2.584 2.584 0 01-2.576 2.592 2.584 2.584 0 01-2.575-2.592 2.583 2.583 0 012.575-2.591 2.584 2.584 0 012.576 2.591z"
            fill="url(#paint1_linear_24105_13370)"
          />
        </G>
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_24105_13370"
          x1={-22.0351}
          y1={14.7996}
          x2={5.11931}
          y2={56.1777}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#EDF1F3" />
          <Stop offset={1} stopColor="#D3DADF" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_24105_13370"
          x1={27.0606}
          y1={15.2629}
          x2={24.004}
          y2={11.648}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#FFA700" />
          <Stop offset={1} stopColor="#E75A10" />
        </LinearGradient>
        <ClipPath id="clip0_24105_13370">
          <Path
            fill="#fff"
            transform="translate(.517)"
            d="M0 0H45.1034V29.5991H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default DiscoverCard;
